(function () {
const $a48f68ed0a1ade6b$export$4ae185e0aa74b989 = (parentEl)=>{
    return [
        ...parentEl.querySelectorAll("a[href]:not([disabled]), button:not([disabled]")
    ].filter((el)=>{
        return getComputedStyle(el).getPropertyValue("display") !== "none";
    });
};
const $a48f68ed0a1ade6b$export$bec45a54c2e66c22 = (e, parentEl)=>{
    const links = $a48f68ed0a1ade6b$export$4ae185e0aa74b989(parentEl);
    const lastFocusableEl = links[links.length - 1];
    const firstFocusableEl = links[0];
    const tabIsPressed = e.keyCode === 9 || e.key === "Tab";
    if (!tabIsPressed) return;
    if (e.shiftKey === true) {
        if (document.activeElement === firstFocusableEl) {
            lastFocusableEl.focus();
            e.preventDefault();
        }
    } else if (document.activeElement === lastFocusableEl) {
        firstFocusableEl.focus();
        e.preventDefault();
    }
};


const $66b7998f79916449$var$bodyScrollLock = (expanded)=>{
    let scrollY = document.body.style.top;
    if (expanded) {
        document.body.style.top = `-${window.scrollY}px`;
        document.body.style.position = "fixed";
    } else {
        document.body.style.position = "";
        document.body.style.top = "";
        window.scrollTo(0, parseInt(scrollY || "0") * -1);
    }
};
var $66b7998f79916449$export$2e2bcd8739ae039 = $66b7998f79916449$var$bodyScrollLock;


const $8965fb9bdb9f7083$var$header = document.querySelector("[data-header]");
const $8965fb9bdb9f7083$var$menuBtn = $8965fb9bdb9f7083$var$header.querySelector('[data-btn="menu"]');
const $8965fb9bdb9f7083$var$menuWrapper = $8965fb9bdb9f7083$var$header.querySelector("[data-menu-wrapper]");
const $8965fb9bdb9f7083$var$homeLink = $8965fb9bdb9f7083$var$header.querySelector("[data-home-link]");
const $8965fb9bdb9f7083$var$open = ()=>{
    const firstMenuLink = (0, $a48f68ed0a1ade6b$export$4ae185e0aa74b989)($8965fb9bdb9f7083$var$menuWrapper)[0];
    $8965fb9bdb9f7083$var$menuWrapper.hidden = false;
    $8965fb9bdb9f7083$var$menuBtn.setAttribute("aria-expanded", true);
    $8965fb9bdb9f7083$var$menuBtn.innerText = "Close";
    firstMenuLink.focus();
    (0, $66b7998f79916449$export$2e2bcd8739ae039)(true);
    setTimeout(()=>{
        $8965fb9bdb9f7083$var$menuWrapper.classList.add("is-visible");
    }, 10);
};
const $8965fb9bdb9f7083$var$close = ()=>{
    $8965fb9bdb9f7083$var$menuWrapper.classList.remove("is-visible");
    setTimeout(()=>{
        $8965fb9bdb9f7083$var$menuWrapper.hidden = true;
        $8965fb9bdb9f7083$var$menuBtn.setAttribute("aria-expanded", false);
        $8965fb9bdb9f7083$var$menuBtn.innerText = "Menu";
        (0, $66b7998f79916449$export$2e2bcd8739ae039)(false);
    }, 250);
};
const $8965fb9bdb9f7083$var$toggleMenu = (e)=>{
    if ($8965fb9bdb9f7083$var$menuWrapper.hidden) $8965fb9bdb9f7083$var$open();
    else $8965fb9bdb9f7083$var$close();
};
const $8965fb9bdb9f7083$var$trapFocusInMenu = (e)=>{
    (0, $a48f68ed0a1ade6b$export$bec45a54c2e66c22)(e, $8965fb9bdb9f7083$var$header);
    /* if Esc key pressed */ if (e.keyCode === 27) $8965fb9bdb9f7083$var$close();
};
const $8965fb9bdb9f7083$var$menu = ()=>{
    $8965fb9bdb9f7083$var$menuBtn.hidden = false;
    $8965fb9bdb9f7083$var$menuWrapper.hidden = true;
    $8965fb9bdb9f7083$var$homeLink.hidden = false;
    $8965fb9bdb9f7083$var$menuWrapper.classList.add("js-menu");
    $8965fb9bdb9f7083$var$menuBtn.addEventListener("click", $8965fb9bdb9f7083$var$toggleMenu);
    $8965fb9bdb9f7083$var$menuWrapper.addEventListener("keydown", $8965fb9bdb9f7083$var$trapFocusInMenu);
};
var $8965fb9bdb9f7083$export$2e2bcd8739ae039 = $8965fb9bdb9f7083$var$menu;


(0, $8965fb9bdb9f7083$export$2e2bcd8739ae039)();

})();
//# sourceMappingURL=index.js.map
